import router from '@/router'

export default {
  bind(el, binding, vnode) {
    let scrollContainer = el.children[2];
    if (!scrollContainer) {
      return;
    }
    let lastScrollTop = 0;
    scrollContainer.onscroll = evt => {
      lastScrollTop = scrollContainer.scrollTop;
    };
    router.afterEach(()=>{
      setTimeout(() => {
        scrollContainer.scrollTop = lastScrollTop
      }, 1000);
    })
  }
}